__turbopack_context__.v({
  "inverseBackground45": "kDDcNW_inverseBackground45",
  "inverseBorder22": "kDDcNW_inverseBorder22",
  "inverseBorder35": "kDDcNW_inverseBorder35",
  "inverseBorder45": "kDDcNW_inverseBorder45",
  "inverseBorder70": "kDDcNW_inverseBorder70",
  "inverseStroke28": "kDDcNW_inverseStroke28",
  "inverseStroke45": "kDDcNW_inverseStroke45",
  "loaderOuter": "kDDcNW_loaderOuter",
  "mobileBackdrop": "kDDcNW_mobileBackdrop",
  "mutedBackground35": "kDDcNW_mutedBackground35",
  "mutedBorder60": "kDDcNW_mutedBorder60",
  "mutedStroke35": "kDDcNW_mutedStroke35",
  "mutedText60": "kDDcNW_mutedText60",
  "navbarGlass": "kDDcNW_navbarGlass",
});
